<template>
    <tbody>
        <tr>
            <td colspan="2" style="background-color: #f3f3f3;"></td>
            
            <td class="text-right" style="background-color: #f3f3f3;">
                Total
            </td>
            
            <td style="background-color: #f3f3f3;">
                {{ totalValue | price }}
            </td>
            
            <td style="background-color: #f3f3f3;"></td>
        </tr>
    </tbody>
</template>

<script>
    export default {
        props: ['buyables'],
        
        computed: {
            totalValue() {
                return this.buyables.reduce((total, buyable) => {
                    return total + buyable.price - (buyable.agency_commission ? buyable.agency_commission : 0)
                }, 0)
            }
        }
    }
</script>
